import PropTypes from 'prop-types'

import { CodeWrapper, CodeBlock, CopyButton } from 'components/common/Codeblock'
import theme from 'theme'
import Button from 'components/common/Button'
import TrackedExternalLink from 'components/common/TrackedExternalLink'

const Windows = ({ colorTheme, ...rest }) => (
  <CodeWrapper {...rest}>
    <div css={{ paddingBottom: theme.space[2] }}>
      <div css={{ display: 'flex', alignItems: 'flex-end' }}>
        <CopyButton
          colorTheme={colorTheme}
          content="msiexec /package https://windows.gremlin.com/installer/latest/gremlin_installer.msi"
        />
      </div>
      <CodeBlock code="msiexec /package https://windows.gremlin.com/installer/latest/gremlin_installer.msi" />
      <Button
        primary
        as={TrackedExternalLink}
        href="https://windows.gremlin.com/installer/latest/gremlin_installer.msi"
      >
        Start install
      </Button>
    </div>
  </CodeWrapper>
)

Windows.propTypes = {
  colorTheme: PropTypes.oneOf(['light', 'dark'])
}

export default Windows
